// extracted by mini-css-extract-plugin
export var image = "_iv-0";